import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LabelOffSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LabelOffSVG;
